"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.someDirtyField = void 0;
const someDirtyField = (dirtyFields, keysToIgnore = []) => {
    for (const name in dirtyFields) {
        if (!keysToIgnore.includes(name) && dirtyFields[name]) {
            return true;
        }
    }
    return false;
};
exports.someDirtyField = someDirtyField;
//# sourceMappingURL=someDirtyField.js.map